import React, { useEffect, useMemo } from 'react';
import { Box, Card, Stack, Typography } from '@mui/material';
import { formatDate, formatKey } from '@/utils/constants';
import { safelyParseDate } from '@/utils/date';

export const SpecialActivityCard = ({ activity }) => {
	const date = useMemo(
		() => (activity ? safelyParseDate(activity.createdDate) : new Date()),
		[activity?.createdDate],
	);

	const getActivityText = () => {
		switch (activity.activityType) {
			case 'prospectToClient':
				return 'Converted Prospect to Client';
			case 'clientToProspect':
				return 'Converted Client to Prospect';
			default:
				return formatKey(activity.activityType);
		}
	};

	return (
		<Box mb='12px'>
			<Card>
				<Stack p='10px'>
					<Typography variant='task_body' fontWeight='bold'>
						<span style={{ fontWeight: 'bold' }}>{getActivityText()}</span>
						<span style={{ margin: '0 0.5em' }}> | </span>
						<span style={{ fontWeight: '500' }}>{formatDate(date, true)}</span>
					</Typography>
				</Stack>
			</Card>
		</Box>
	);
};
